import {IconButton, Snackbar } from '@mui/material'
import Icon from 'components/icons/Icon'
import React, { useState } from 'react'
import { CommonUtil } from 'utils/CommonUtil'
import { UseToastStore, Update as ToastUpdate } from 'stores/ToastStore';
import { Toast } from 'stores/models/Toast';
import Dialog from 'components/modals/Dialog';
import LoadingButton from './LoadingButton';
import Form from 'components/forms/Form';
import FieldCollection from 'components/fields/fieldCollection/FieldCollection';
import TextField from 'components/fields/textField/TextField';
import Button from './Button';
import { Bootstrapper } from 'Bootstrapper';
import { UserService } from 'services/UserService';
import { InlineWidget, PopupButton } from 'react-calendly';
import { Link } from 'react-router-dom';





const RequestDemoButton = (props: any) => {
    // const {content, ...rest} = props
    const userService = Bootstrapper.getInstance<UserService>(UserService);


    return (
        <Button component={Link} to={'/demo'} variant='outlined' {...props}>
          Request Demo
        </Button>
    )
}

export default RequestDemoButton